import reducer from './reducer'

export const NAMESPACE = 'qmr-viewer'

export default { [NAMESPACE]: reducer }
